import React from "react";

import { StyledSVG } from "../StyledIcon";

export const GithubIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path d="M12 1.5C10.6211 1.5 9.25574 1.77833 7.98182 2.31911C6.7079 2.85988 5.55039 3.65251 4.57538 4.65173C2.60625 6.66975 1.5 9.40677 1.5 12.2607C1.5 17.0169 4.5135 21.0522 8.682 22.4833C9.207 22.5694 9.375 22.2358 9.375 21.9453C9.375 21.6978 9.375 21.0199 9.375 20.1267C6.4665 20.7724 5.847 18.6848 5.847 18.6848C5.364 17.4366 4.6815 17.103 4.6815 17.103C3.726 16.4358 4.755 16.4573 4.755 16.4573C5.805 16.5327 6.3615 17.5657 6.3615 17.5657C7.275 19.2013 8.8185 18.7171 9.417 18.4588C9.5115 17.7594 9.7845 17.2859 10.0785 17.0169C7.7475 16.7479 5.301 15.8225 5.301 11.7226C5.301 10.5282 5.7 9.57051 6.3825 8.8065C6.2775 8.53749 5.91 7.41838 6.4875 5.96568C6.4875 5.96568 7.3695 5.67515 9.375 7.06327C10.2045 6.82654 11.1075 6.70817 12 6.70817C12.8925 6.70817 13.7955 6.82654 14.625 7.06327C16.6305 5.67515 17.5125 5.96568 17.5125 5.96568C18.09 7.41838 17.7225 8.53749 17.6175 8.8065C18.3 9.57051 18.699 10.5282 18.699 11.7226C18.699 15.8332 16.242 16.7371 13.9005 17.0061C14.2785 17.3397 14.625 17.9961 14.625 18.9969C14.625 20.4388 14.625 21.601 14.625 21.9453C14.625 22.2358 14.793 22.5802 15.3285 22.4833C19.497 21.0414 22.5 17.0169 22.5 12.2607C22.5 10.8476 22.2284 9.44829 21.7007 8.14275C21.1731 6.8372 20.3996 5.65095 19.4246 4.65173C18.4496 3.65251 17.2921 2.85988 16.0182 2.31911C14.7443 1.77833 13.3789 1.5 12 1.5Z"
      fill={iconColor}
      />
    </StyledSVG>
  );
};
